import React, { HTMLProps, ReactNode } from "react";
import styled from "styled-components";
import { DiscoverCardsStatusEnum } from "../discover-cards.model";

export interface ISubBundleStatusChipProps extends HTMLProps<HTMLDivElement> {
  type: DiscoverCardsStatusEnum;
  children: ReactNode;
}

const DiscoverCardStatusChip = ({ type, children, ref, as, ...rest }: ISubBundleStatusChipProps) => {
  return (
    <StatusChipContainer type={type} {...rest}>
      {children}
    </StatusChipContainer>
  );
};

export default DiscoverCardStatusChip;

export const StatusChipContainer = styled("div")<{ type: DiscoverCardsStatusEnum }>`
  border-radius: 10px;
  padding-left: 12px;
  padding-right: 12px;
  height: 22px;
  line-height: 21px;
  font-weight: bold;
  display: inline-block;
  font-size: 14px;
  text-align: center;
  font-family: Vodafone Rg;

  ${props => {
    let backgroundColor = "";
    let fontColor = props.theme.palette.white;
    let borderColor = "";
    switch (props.type) {
      case DiscoverCardsStatusEnum.LIVE:
        backgroundColor = props.theme.palette.digitalGreen;
        borderColor = props.theme.palette.digitalGreen;
        break;
      case DiscoverCardsStatusEnum.DISABLE:
        backgroundColor = props.theme.palette.white;
        borderColor = props.theme.palette.freshOrange;
        fontColor = props.theme.palette.freshOrange;
        break;
      case DiscoverCardsStatusEnum.DISABLED:
        backgroundColor = props.theme.palette.freshOrange;
        borderColor = props.theme.palette.freshOrange;
        break;
      case DiscoverCardsStatusEnum.ENABLE:
      case DiscoverCardsStatusEnum.EDIT:
        backgroundColor = props.theme.palette.white;
        fontColor = props.theme.palette.digitalGreen;
        borderColor = props.theme.palette.digitalGreen;
        break;
      case DiscoverCardsStatusEnum.DELETE:
        backgroundColor = props.theme.palette.vodafoneRed;
        borderColor = props.theme.palette.vodafoneRed;
        break;
    }
    return `background-color: ${backgroundColor}; color: ${fontColor}; border: 1px solid ${borderColor}`;
  }}
`;
